<template>
  <div>
    <h1 style="margin: 20px">Business skills for {{user.firstName}} {{user.lastName}}</h1>
    <table border="1" style="margin: 0 auto">
      <tbody v-for="service in services" :key="service.id">
        <tr><th>{{service.title}}</th><th><a style="cursor: pointer; color: green" v-on:click="toggleAll(service.id)">Select all</a></th></tr>
        <tr v-for="skill in service.skills" :key="skill.id"><td>{{skill.title}}</td><td><input type="checkbox" v-model="selectedSkills[skill.id]" /></td></tr>
      </tbody>
    </table>
    <button v-on:click="saveBusinessSkills()" style="background-color: #333;padding: 10px;color:white;cursor:pointer;margin-top:20px">Save business skills</button>
  </div>
</template>

<style scoped>
  td, th {
    padding: 10px;
  }
</style>

<script>
import api from '../services/api';

export default {
  name: 'jobs',
    data: function() {
    return {
      services: [],
      user: {},
      selectedSkills: {}
    }
  },
  methods: {
    async saveBusinessSkills() {
      await api.setBusinessSkills(this.$route.params.id, {skills: Object.keys(this.selectedSkills).filter(key => this.selectedSkills[key]) || []});
      this.$router.push({ name: "userProfile" , params: {id: this.$route.params.id}}).catch(() => {});
    },
    toggleAll(serviceId) {
      this.services.forEach(service => {
        if (service.id === serviceId) {
          let foundEmpty = false;
          service.skills.forEach(skill => {
            if (!this.selectedSkills[skill.id]) {
              foundEmpty = true;
            }
          });
          service.skills.forEach(skill => {
            this.selectedSkills[skill.id] = foundEmpty;
            // console.log('mark', !foundEmpty);
          });
          this.selectedSkills = {...this.selectedSkills};
          // console.log(foundEmpty, this.selectedSkills);
        }
      });
    }
  },
  created: async function() {
    this.user = await api.getUser(this.$route.params.id);
    (this.user.businessSkills || []).forEach(skill => this.selectedSkills[skill] = true);
    const skills = this.$store.state.skills;
    this.services = Object.values(this.$store.state.services).sort((s1, s2) => {
      return s2.sortPriority - s1.sortPriority;
    }).map(service => {
      service.title = service.localizedTitle.lt;
      service.skills = Object.values(skills).filter(s => s.hourlyRate && s.serviceId === service.id).map(s => {
        s.title = s.localizedTitle.lt;
        return s;
      }).sort((s1, s2) => {
        return s2.sortPriority - s1.sortPriority;
      });
      return service;
    }).filter(service => service.skills.length);
  }
}
</script>